import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import { useField, useFormikContext, ErrorMessage } from "formik";
import FormikLabel from "./FormikLabel";
import { ErrorStyle } from "./ErrorStyle";

const FormikEmailInput = ({
  name,
  label,
  width = "100%",
  required = false,
  placeholder = "Enter your email",
  disabled = false,
  readOnly = false,
  onChange = () => {},
  ...props
}) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();

  return (
    <div style={{  width }}>
      <FormikLabel text={label} required={required} />
      <TextField
        {...field}
        type="email"
        {...props}
        placeholder={placeholder}
        fullWidth
        disabled={disabled}
        inputProps={{
          readOnly: readOnly,
        }}
        onChange={(e) => {
          if (!readOnly) {
            setFieldValue(name, e.target.value);
            onChange(e);
          }
        }}
        sx={{
          ...props.sx,
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            borderWidth: "1px",
          },
          "& .MuiInputBase-input": {
            backgroundColor: disabled || readOnly ? "#f5f5f5" : "inherit",
            padding: "8px",
          },
        }}
      />
      <div style={ErrorStyle}>
        <ErrorMessage name={name} />
      </div>
    </div>
  );
};

// PropTypes for validation
FormikEmailInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  width: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default FormikEmailInput;
